import React, { Fragment } from "react";

// Common Components
import Attachment from '@Components/Common/Attachment';
import ViewDocumentFooterDetails from "@Components/Common/ViewDocFooterLeftSection";

// Helpers & Constants
import Helpers from '@Apis/helpers';

// UI Library
import H3Text from '@Uilib/h3Text';

function ViewDCFooter ({
  props,
  state,
  updateState,
}) {

  const {
    selectedDC,
    match,
    updateAttachment,
    getAttachmentById,
    getAttachmentByIdLoading,
    updateAttachmentLoading,
    user,
  } = props;

  const {
    fileList,

  } = state;

  const handleFileChange = (fileListData) => {

    const fileList = fileListData?.fileList?.map((item) => ({
      ...item,
      url: item?.response?.response?.location || item?.url,
    }));

    const attachments = fileList?.map((attachment) => ({
      url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
    }));

    if (fileListData?.file.status === 'done') {
      const payload = {
        entity_id: selectedDC?.delivery_challan_id,
        entity_name: 'dc',
        attachments,
      };
      updateAttachment(payload, () => {
        getAttachmentById(selectedDC?.delivery_challan_id, 'dc', () => {
          updateState ({
            isGetAttachment: true,
          });
        });
      });
    }
    if (fileListData?.file.status === 'removed') {
      const payload = {
        entity_id: selectedDC?.delivery_challan_id,
        entity_name: 'dc',
        attachments,
      };
      updateAttachment(payload, () => {
        getAttachmentById(selectedDC?.delivery_challan_id, 'dc', () => {
          updateState ({
            isGetAttachment: true,
          });
        });
      });
    }

    updateState ({
      fileList: attachments.length > 0 ? attachments : [],
    });
  };

  return (
    <div className="view-document__totals-wrapper">
      <ViewDocumentFooterDetails
        remark={selectedDC?.remark}
        fileList={fileList}
        disableAttachment={getAttachmentByIdLoading || updateAttachmentLoading}
        onFileChange={handleFileChange}
        canUpdateAttachment={Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.UPDATE, user)}
        termsAndConditions={selectedDC?.t_and_c}
      />
    </div>
  );
};

export default ViewDCFooter;